export interface IKidneyAvailOnTimeReport {
    id: number,
    transplantedDate: string,
    swapNumber: number,
    clusterNumber: number,
    position: number,
    recipientCenter: number,
    recipientAlias: number,
    donorCenter: string,
    remoteDonorCenter: string,
    donorAlias: string,
    timeExpected: string,
    timeActual: string,
    minuteDifference: number,
    lateness: string,
    latenessSort: number
}